<template>
  <div class="drop-down-selection">
    <div
      :id="belongsToId"
      :class="[
        'drop-down-selection__row',
        disabled ? 'disabled' : '',
        cssClass,
        { selected: selectedID === belongsToId }
      ]"
      @mouseleave="onLeave"
      @mouseover="onHover"
      @click="select(disabled)"
    >
      {{ title }}
    </div>
    <div v-if="showHoverExplanationText" class="hover-explanation">
      <p class="hover-explanation-text">
        {{ title }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DropDownSelectionRow',
  props: {
    hoverExplanationText: {
      type: String,
      default: 'undefined',
      required: false
    },
    value: {
      type: [Number, String],
      required: true
    },
    title: {
      type: String,
      required: true
    },
    belongsToId: {
      type: [String, Number],
      default: ''
    },
    cssClass: {
      type: String,
      validator: (prop) => {
        return ['dark', 'light', 'color'].includes(prop)
      },
      default: 'color'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    selectedID: {
      validator: (value) => typeof value === 'string' || value == null,
      required: true
    }
  },
  emits: ['selected'],
  data() {
    return {
      showHoverExplanationText: false
    }
  },
  computed: {},
  methods: {
    select(disabled) {
      if (disabled) return
      this.$emit('selected', this.value, this.title, this.belongsToId)
    },
    onHover(e) {
      const targetEl = e.target
      this.showHoverExplanationText = targetEl.offsetWidth < targetEl.scrollWidth
    },
    onLeave() {
      this.showHoverExplanationText = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import 'src/styles/variables.scss';
.drop-down-selection {
  position: relative;
}
.drop-down-selection__row {
  height: 40px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-family: $font-family-general-paragraph;
  font-size: $font-size-dropdown-filter-menu;
  padding: 8px $margin-drop-down-filter;
  color: $color-text-white-70;
  background-color: $color-grey-blue-dark;
  &.color {
    background-color: $color-primary;
    &:hover {
      background-color: $color-primary-dark;
    }
  }
  &.disabled {
    cursor: not-allowed;
    color: $color-grey-darker;
  }
  &.light {
    background-color: $color-grey-light;
    color: $color-grey-darker;
    &:hover {
      background-color: $color-grey;
    }
  }
  &.dark {
    &:hover {
      background-color: $color-grey-blue-darker;
    }
  }
}
.selected {
  font-weight: $font-weight-general-heading;
  color: $color-text-white;
}
.hover-explanation {
  background-color: rgba(0, 0, 0, 0.8);
  box-shadow: $box-shadow-overview-button;
  left: 0;
  z-index: 10;
  border-radius: 4px;
  padding: 2px 5px;
  justify-content: center;
  min-width: 100%;
  position: absolute;
  text-align: center;
  &-text {
    color: $color-text-white-70;
    flex-direction: column-reverse;
    margin: 0;
  }
}
</style>
